import { BuzerIcon, ICON_NAMES } from "../../BuzerIcons";
import { resolveIcon } from "../../lib/icons-resolve";
import { fmtDuePretty } from "../../lib/date-sk";

// v9 — a due-date label with the calendar BuzerIcon (replaces the legacy "📅 " text prefix).
export function DueLabel({ due, end, none = "" }) {
  if (!due) return none ? <>{none}</> : null;
  return <><BuzerIcon name="calendar" size={12} color="var(--muted)" style={{ verticalAlign: "-2px", marginRight: 3 }} />{fmtDuePretty(due, end)}</>;
}

// v8 — render a habit/category glyph: a BuzerIcon if `icon` is a set name or a known legacy emoji,
// else the raw emoji string as a last resort.
// v28.10 — POISTKA: uložená hodnota môže byť aj „skomolený" NÁZOV ikony (orezaný limitom, alebo
// názov z inej sady) — napr. 'footprin' či 'butterfly'. Taký reťazec sa predtým vypísal ako HOLÝ
// TEXT v riadku výzvy. Ak ide o čisto ASCII slovo, ktoré sada nepozná, vykreslíme radšej záložnú
// ikonu; emoji (čokoľvek mimo ASCII) sa naďalej ukáže tak, ako ho človek zadal.
export function Glyph({ icon, size = 22, fallback = "target" }) {
  const name = resolveIcon(icon) || (!icon ? fallback : "");
  if (name && ICON_NAMES.includes(name)) return <BuzerIcon name={name} size={size} />;
  if (icon && /^[\x20-\x7e]+$/.test(icon)) return <BuzerIcon name={fallback} size={size} />;
  return <span>{icon || fallback}</span>;
}
